import React from 'react'
import { Box, Button, Typography } from '@mui/material'
import { useTranslations } from 'next-intl'

interface BaggageRetryButtonProps {
    onRetry: () => void
    boxSx?: object
    buttonSx?: object
}

const BaggageRetryButton: React.FC<BaggageRetryButtonProps> = ({ 
    onRetry, 
    boxSx = {},
    buttonSx = {}
}) => {
    const tCommon = useTranslations('common')
    
    return (
        <Box sx={{ textAlign: 'right', ...boxSx }}>
            <Button
                size="small"
                variant="outlined"
                onClick={onRetry}
                sx={{ padding: '5px', ...buttonSx }}
            >
                <Typography variant="caption" fontWeight="bold" sx={{ fontSize: '10px', display: 'flex', alignItems: 'center', mr: 0.3 }}>
                    {tCommon('retry')}
                </Typography>
                <Typography variant="caption" fontWeight="bold" sx={{ fontSize: '10px', display: 'flex', alignItems: 'center', mr: 0.3 }}>
                    {tCommon('baggage')}
                </Typography>
            </Button>
        </Box>
    )
}

export default BaggageRetryButton